import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InHouseStats from '../_InHouseStats'
import ProStats from '../_ProStats'

interface Props {
  inHousePayroll: boolean
}

const Stats = ({ inHousePayroll }: Props) => {
  return (
    <Box flexDirection="row" background="white" gap={'s12'} justifyContent="center">
      {inHousePayroll ? <InHouseStats /> : <ProStats />}
    </Box>
  )
}

export default observer(Stats)
